export const sizeInSteps = (size, step = 50) => Math.ceil(size / step) * step;
